import { removeTypename } from '@cosuno/apollo';

import { COMPANY_TYPE } from '#@/__gql__/graphql';

import { AUTH_STATUS } from '../constants';
import { isAnonymous, isAuthenticated } from '../contexts/authContext';
import type { UserComplete } from '../types';
import useAuthContext from './useAuthContext';

interface UserAuthState {
  isUserPrincipal: boolean;
  isUserAgent: boolean;
  isUserAuthenticated: boolean;
  isUserAuthenticating: boolean;
  isUserAnonymous: boolean;
  companyType: COMPANY_TYPE | undefined;
  currentUser: UserComplete | null;
}

const useUserAuthState = (): UserAuthState => {
  const authContext = useAuthContext();
  const isUserAuthenticated = isAuthenticated(authContext);
  const isUserAnonymous = isAnonymous(authContext);

  const isUserAuthenticating = authContext.authState.status === AUTH_STATUS.authenticating;

  const isUserPrincipal =
    isUserAuthenticated && authContext.authState.companyType === COMPANY_TYPE.principal;

  const isUserAgent =
    isUserAuthenticated && authContext.authState.companyType === COMPANY_TYPE.agent;

  const companyType = isUserAuthenticated ? authContext.authState.companyType : undefined;
  const currentUser = isUserAuthenticated ? removeTypename(authContext.authState.user) : null;

  return {
    isUserPrincipal,
    isUserAgent,
    isUserAuthenticated,
    isUserAuthenticating,
    isUserAnonymous,
    companyType,
    currentUser,
  };
};

export default useUserAuthState;
